import PropTypes from 'prop-types';
import { activityMasteryPropTypeShape } from '../../../components/activity-status-bar/activity-mastery-prop-type';

const strengthWeaknessData = PropTypes.shape({
    id: PropTypes.number.isRequired,
    title: PropTypes.string.isRequired,
    averageResult: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
        .isRequired
});

const activityMasteryData = PropTypes.shape({
    name: PropTypes.string.isRequired,
    teacherName: PropTypes.string.isRequired,

    activityMastery: PropTypes.shape({
        ...activityMasteryPropTypeShape,

        groupActivityMastery: PropTypes.arrayOf(
            PropTypes.shape({
                id: PropTypes.number.isRequired,
                name: PropTypes.string.isRequired,
                courseName: PropTypes.string.isRequired,
                totalActivities: PropTypes.number.isRequired,

                students: PropTypes.arrayOf(
                    PropTypes.shape({
                        ...activityMasteryPropTypeShape,
                        id: PropTypes.number.isRequired,
                        firstName: PropTypes.string.isRequired,
                        lastName: PropTypes.string.isRequired
                    })
                ),

                strengths: PropTypes.shape({
                    topics: PropTypes.arrayOf(strengthWeaknessData),
                    activities: PropTypes.arrayOf(strengthWeaknessData)
                }).isRequired,

                weaknesses: PropTypes.shape({
                    topics: PropTypes.arrayOf(strengthWeaknessData),
                    activities: PropTypes.arrayOf(strengthWeaknessData)
                }).isRequired
            })
        )
    }),

    strengths: PropTypes.shape({
        topics: PropTypes.arrayOf(strengthWeaknessData),
        activities: PropTypes.arrayOf(strengthWeaknessData)
    }).isRequired,

    weaknesses: PropTypes.shape({
        topics: PropTypes.arrayOf(strengthWeaknessData),
        activities: PropTypes.arrayOf(strengthWeaknessData)
    }).isRequired
});

export default {
    activityMasteryData
};



// WEBPACK FOOTER //
// ./containers/activity-mastery/single-class/single-class-prop-types.js